import IRBGrid from "./IRBGrid";

export default function IRBProjectStatus(props) {
  const { sales } = props;

  return (
    <div>
      <div>
        <IRBGrid sales={sales} />
      </div>
      <div></div>
    </div>
  );
}
